import { DIYA, DIYA_DOTS, NAVY, PINK, YELLOW, CREAM, SPARKLE, marigoldPetals, sunburstPolys } from "@/lib/artPaths";

const diya = (tx, ty, s) => `<g transform="translate(${tx} ${ty}) scale(${s})">
  <path d="${DIYA.flameOuter}" fill="${YELLOW}" stroke="${NAVY}" stroke-width="5" stroke-linejoin="round"/>
  <path d="${DIYA.flameInner}" fill="${CREAM}" stroke="${NAVY}" stroke-width="3"/>
  <path d="M120 100 L120 114" stroke="${NAVY}" stroke-width="5" stroke-linecap="round"/>
  <path d="${DIYA.base}" fill="${YELLOW}" stroke="${NAVY}" stroke-width="5" stroke-linejoin="round"/>
  <path d="${DIYA.bowl}" fill="${PINK}" stroke="${NAVY}" stroke-width="5" stroke-linejoin="round"/>
  <path d="${DIYA.zig}" fill="none" stroke="${NAVY}" stroke-width="3.5"/>
  ${DIYA_DOTS.map((x) => `<circle cx="${x}" cy="166" r="5" fill="${CREAM}" stroke="${NAVY}" stroke-width="2.5"/>`).join("")}
  <path d="${DIYA.rim}" fill="${YELLOW}" stroke="${NAVY}" stroke-width="5" stroke-linejoin="round"/>
</g>`;

const marigold = (x, y, s) =>
  `<g transform="translate(${x} ${y}) scale(${s})">${marigoldPetals(14)
    .map((p, i) => `<circle cx="${p.x}" cy="${p.y}" r="${p.r}" fill="${i % 2 ? "#F59E0B" : YELLOW}" stroke="${NAVY}" stroke-width="1.8"/>`)
    .join("")}<circle r="4.8" fill="${PINK}" stroke="${NAVY}" stroke-width="1.8"/></g>`;

const sparkle = (x, y, s, c = YELLOW) => `<path transform="translate(${x} ${y}) scale(${s})" d="${SPARKLE}" fill="${c}" stroke="${NAVY}" stroke-width="2"/>`;

export function passHeaderSvg(accentHex) {
  const rays = sunburstPolys(24, 520).map((p) => `<polygon points="${p}" fill="${YELLOW}" opacity=".9"/>`).join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 500" width="1080" height="500">
  <defs><pattern id="d" width="26" height="26" patternUnits="userSpaceOnUse"><circle cx="13" cy="13" r="2.6" fill="${CREAM}" opacity=".28"/></pattern>
  <clipPath id="c"><rect width="1080" height="500"/></clipPath></defs>
  <g clip-path="url(#c)">
    <rect width="1080" height="500" fill="${PINK}"/>
    <rect width="1080" height="500" fill="url(#d)"/>
    <g transform="translate(540 300)">${rays}</g>
    <circle cx="540" cy="300" r="150" fill="${CREAM}" stroke="${NAVY}" stroke-width="7"/>
    <circle cx="540" cy="300" r="128" fill="none" stroke="${accentHex}" stroke-width="10"/>
    ${diya(390, 190, 1.25)}
    ${marigold(120, 110, 2.6)}${marigold(960, 120, 2.2)}${marigold(180, 400, 1.8)}${marigold(900, 410, 2.4)}
    ${sparkle(300, 80, 2.4)}${sparkle(800, 70, 1.8, CREAM)}${sparkle(80, 260, 1.6, CREAM)}${sparkle(1000, 280, 2)}
    <rect y="472" width="1080" height="28" fill="${accentHex}"/>
    <line x1="0" y1="472" x2="1080" y2="472" stroke="${NAVY}" stroke-width="6"/>
  </g>
</svg>`;
}

export const svgToDataUrl = (svg) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
